<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-07-15 09:35:44
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-07-15 16:05:56
 * @FilePath: \newpigboxmanger\src\views\login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mylogonBox">
    <div class="mainLoginBox">
      <div class="mainLoginBoxTitle">四小碗后台运营管理平台登录</div>
      <div class="mainInputBox">
        <div class="mylableBox"> 运维账号：</div>
        <div style="margin-top:15px">
              <el-input v-model="username" placeholder="请输入内容"></el-input>
        </div>
         <div class="mylableBox" style="margin-top:15px"> 运维密码：</div>
        <div style="margin-top:15px">
              <el-input v-model="password" placeholder="请输入内容" type=""></el-input>
        </div>
        <div style="margin-top:15px">
             <el-button  type="primary" @click="getuserData">进入系统<i class="el-icon-right"></i></el-button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      username:"",
      password:"",
      userData:{},
      
    }
  },
  methods:{
    getuserData(){
       this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getSXWUserData&userId=${this.username}&pwd=${this.password}`,
       
      }).then((res)=>{
        console.log(res.data.dataList.length);
        // return
        if(res.data.dataList.length!=0){
            this.$store.commit("setloginData",res.data.dataList[0].merchant_id)
            this.$router.push('/shop')
        }else{
           this.$message.error('账号密码错误');
        }
      
      })
    }
  }
}
</script>

<style>
    .mylogonBox{
        height: 100vh;
        width: 100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("../assets/banner.jpg");
        background-size: 100% 100%;
        /* background-color: bisque; */
        
    }
    .mainLoginBox{
      height: 500px;
      width: 500px;
      background-color: rgba(255, 255, 255, 0.372);
      border-radius: 15px;
       backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
    }
    .mainLoginBoxTitle{
      height: 50px;
      width: 100%;
      text-align: center;
      line-height: 50px;
    }
    .mainInputBox{
      height: 300px;
      width: 100%;
      margin-top: 100px;
      /* background-color: aqua; */
      padding: 20px;
    }
    .mylableBox{
      text-align: left;
    }
</style>